// extracted by mini-css-extract-plugin
module.exports = {"paper":"LoginForm_paper__I0QeX","button":"LoginForm_button__3cSv8","message":"LoginForm_message__1NjQ3","applink":"LoginForm_applink___-l_m"};